import ServerRequestUtil from '../utils/ServerRequestUtil';
import JSCookie from "js-cookie";
import config from "../../config";

export default new class {

    constructor() {
        this.listRequest = undefined;
        this.listData = undefined;
    }

    getCurrentLanguageCode() {
        return JSCookie.get('app_locale') ? JSCookie.get('app_locale') : config.defaultLanguage;
    }

    /**
     * 短縮使用言語を返却する{en/ja}
     * @returns {string}
     */
    getCurrentLanguageShortCode() {
        const languageCode = this.getCurrentLanguageCode();
        return languageCode.substr(0, 2);
    }

    updateUserLanguageCode(languageCode) {
        const data = {
            code: languageCode
        };

        return ServerRequestUtil.post('api/app/users/change-language-code', data, false);
    }

    async getLanguageCodes() {
        if (this.listData) {
            return new Promise((suc, rej) => {
                suc({data: this.listData});
            });
        }

        if (this.listRequest) {
            return new Promise(async (suc, rej) => {
                try {
                    const result = await this.listRequest;
                    this.listData = result.data;
                    this.listRequest = undefined;
                    suc(result);
                } catch (e) {
                    rej(e);
                }
            });
        }

        this.listRequest = ServerRequestUtil.get('api/common/language-codes', {}, false);
        return this.listRequest;
    }
}
